"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingObserver = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const fs = require("fs");
class LoggingObserver {
    constructor(logFilePath) {
        this.logFilePath = logFilePath;
        this.log = [];
    }
    post(event) {
        this.writeLine(`${new Date().toLocaleString()} ${new Date().getMilliseconds()} ${event.eventName}`);
        const properties = event.getProperties();
        if (properties) {
            for (const property of Object.values(properties)) {
                this.writeLine(property);
            }
        }
        this.writeLine('');
    }
    dispose() {
        fs.writeFileSync(this.logFilePath, this.log.join('\n'));
    }
    getFileLocation() {
        return this.logFilePath;
    }
    writeLine(line) {
        this.log.push(line);
    }
}
exports.LoggingObserver = LoggingObserver;
//# sourceMappingURL=LoggingObserver.js.map